import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-2 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = {
  key: 0,
  class: "text-catering-ink-500"
}
const _hoisted_4 = { class: "mb-1 font-semibold text-catering-ink-900" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-0.5"
}
const _hoisted_6 = {
  key: 1,
  class: "text-catering-ink-500"
}
const _hoisted_7 = {
  key: 2,
  class: "mt-1 text-[11px] text-catering-ink-500"
}


export default {
  __name: 'BotSlotProducts',
  props: { block: { type: Object, required: true } },
  setup(__props) {


const staplePreview = store => {
  const sample = store.always_available_sample || []
  if (!sample.length) return ''
  const suffix = store.always_available_count > sample.length ? '…' : ''
  return ` (${sample.join(', ')}${suffix})`
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.block.day_of_week) + " " + _toDisplayString(__props.block.date), 1),
    (!__props.block.stores || !__props.block.stores.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Nothing scheduled for this date. "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.stores || [], (store, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "mb-3 last:mb-0"
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(store.store_name), 1),
        (store.scheduled && store.scheduled.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(store.scheduled, (p, j) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: j,
                  class: "flex items-center gap-2 text-catering-ink-800"
                }, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", {
                    class: "h-1.5 w-1.5 shrink-0 rounded-full bg-catering-honey-500",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(p.name), 1)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_6, "No items scheduled just for this date.")),
        (store.always_available_count)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, " + " + _toDisplayString(store.always_available_count) + " always-available" + _toDisplayString(staplePreview(store)), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

}